import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './ModalShell.scss';

export default function ModalShell({
                                       isOpen = true,
                                       title,
                                       onClose,
                                       zIndex,
                                       backdropClosable = true,
                                       children
                                   }) {
    return (
        <AnimatePresence>
            {isOpen && (
                <div
                    aria-modal="true"
                    role="dialog"
                    className="modal-shell"
                    style={{ zIndex }} // z-index necháme dynamický přes inline, zbytek je v SCSS
                >
                    {/* Backdrop */}
                    <motion.div
                        className="modal-shell__backdrop"
                        onClick={() => {
                            if (backdropClosable) onClose?.({ dismissed: true, reason: 'backdrop' });
                        }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                    />

                    {/* Wrapper (nebere pointery) */}
                    <div className="modal-shell__wrapper">
                        {/* Panel */}
                        <motion.div
                            className="modal-shell__panel"
                            initial={{ opacity: 0, y: -10, scale: 0.98 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: -10, scale: 0.98 }}
                            transition={{ duration: 0.2, ease: 'easeOut' }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="modal-shell__header">
                                <h3 className="modal-shell__title">{title || 'Dialog'}</h3>
                                <button
                                    aria-label="Zavřít"
                                    className="modal-shell__close"
                                    onClick={() => onClose?.({ dismissed: true, reason: 'close' })}
                                >
                                    ×
                                </button>
                            </div>

                            <div className="modal-shell__body">
                                {children}
                            </div>

                            {/* Volitelně:
              <div className="modal-shell__footer">
                ...
              </div>
              */}
                        </motion.div>
                    </div>
                </div>
            )}
        </AnimatePresence>
    );
}
